import React from 'react';
import { useTranslation } from 'react-i18next';

import { EMTPY_LIST_ITEMS } from '@common/constants';
import { ComponentCustomization } from '@core/types';
import { noop } from '@utils';
import MeasurementItem from './MeasurementItem';

interface MeasurementTableProps {
	title: string;
	data?: Array<{
		uid: string | number;
		label: string;
		displayText: string[];
		isActive: boolean;
	}>;
	onClick?: (..._args) => void;
	onEdit?: (..._args) => void;
}

const MeasurementTable = ({
	data = EMTPY_LIST_ITEMS,
	title,
	onClick = noop,
	onEdit = noop,
	servicesManager,
}: withAppTypes<MeasurementTableProps>) => {
	const { customizationService } = servicesManager.services;
	const { t } = useTranslation('MeasurementTable');
	const amount = data.length;

	const itemCustomization = customizationService.getCustomization('MeasurementItem', {
		id: 'MeasurementItem',
		content: MeasurementItem,
		contentProps: {},
	}) as ComponentCustomization;
	const CustomMeasurementItem = itemCustomization.content;

	return (
		<div>
			<div className="flex justify-between bg-secondary-main px-2 py-1">
				<span className="text-base font-bold uppercase tracking-widest text-white">{t(title)}</span>
				<span className="text-base font-bold text-white">{amount}</span>
			</div>
			<div className="saola-scrollbar max-h-112 overflow-hidden">
				{data.length !== 0 &&
					data.map((measurementItem, index) => (
						<CustomMeasurementItem
							key={measurementItem.uid}
							uid={measurementItem.uid}
							index={index + 1}
							label={measurementItem.label}
							isActive={measurementItem.isActive}
							displayText={measurementItem.displayText}
							item={measurementItem}
							onClick={onClick}
							onEdit={onEdit}
						/>
					))}
				{data.length === 0 && (
					<div className="group flex cursor-default border border-transparent bg-black transition duration-300">
						<div className="w-6 bg-primary-dark py-1 text-center text-base text-primary-light transition duration-300 group-hover:bg-secondary-main"></div>
						<div className="flex flex-1 items-center justify-between px-2 py-4">
							<span className="mb-1 flex flex-1 items-center text-base text-primary-light">
								{t('No tracked measurements')}
							</span>
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default MeasurementTable;
